<template>
    <div class="input-container">
        <label>
            <input v-model="value"
                   :name="name"
                   :type="dataType"
                   autocomplete="off"
                   @focus="customFocus"
                   @blur="isEdited = true"
                   @input="isEdited = true"
                   :disabled="!isEditable || isDisabled"

            />
            <span :class="{incorrect: validate && isEdited, beforeVisit : !isVisited}"
                  class="custom_placeholder"
                  v-html="placeholder">
            </span>
        </label>
        <transition name="fade">
             <span class="error-display"
                   v-if="validate && isEdited"
                   v-html="translate(errorMsg)">
        </span>
        </transition>

    </div>
</template>

<script>
    export default {
        name: "inputCustom",
        props: ['placeholder', 'dataType', 'regex', 'require', 'name', 'startValue', 'forceStartValue', 'isDisabled'],
        data() {
            return {
                value: '',
                isVisited: false,
                isIncorect: false,
                isEdited: false,
                errorMsg: 'error_msg_empty_field',
                type: ''
            }
        },

        methods: {

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            customFocus() {
                this.isVisited = true;
            },

            emitValidateData() {

                this.customFocus();
                this.isEdited = true;

                this.$parent.$emit('validateData', {
                    title: this.name,
                    isIncorect: this.validate,
                    value: this.validate ? '' : this.value,
                });
            },
        },

        computed: {
            validate() {

                if (this.require) {
                    if (this.regex) {
                        return !this.regex.test(this.value);
                    } else {
                        return this.value === '';
                    }
                } else {
                    return false;
                }
            },

            isEditable() {
                return this.$store.getters.isOfferEditable;
            }
        },

        mounted() {
            this.$parent.$on('getValidateData', () => {
                this.emitValidateData();
            });

            // NVS-176
            if (this.forceStartValue) {
                this.value = this.startValue;
                this.isVisited = true;
                return;
            }

            if (this.$store.state.productCard.custom.summary_form[this.name] !== undefined) {
                this.value = this.$store.state.productCard.custom.summary_form[this.name].value;
                this.isVisited = true;
            } else if(this.startValue) {
                this.value = this.startValue;
                this.isVisited = true;
            }
        }
    }
</script>

<style scoped lang="scss">

    .fade-enter-active, .fade-leave-active {
        transition: all 0.3s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
        transform: scale(0);
    }
</style>